import {
  SE_CONTRACT_GET_LIST,
  SE_CONTRACT_GET_LIST_SUCCESS,
  SE_CONTRACT_GET_LIST_ERROR,
  SE_CONTRACT_GET_BY_ID,
  SE_CONTRACT_GET_BY_ID_SUCCESS,
  SE_CONTRACT_GET_BY_ID_ERROR,
  SE_CONTRACT_ADD_ITEM,
  SE_CONTRACT_ADD_ITEM_SUCCESS,
  SE_CONTRACT_ADD_ITEM_ERROR,
  SE_CONTRACT_EDIT_ITEM,
  SE_CONTRACT_EDIT_ITEM_SUCCESS,
  SE_CONTRACT_EDIT_ITEM_ERROR,
  SE_CONTRACT_DELETE_ITEM,
  SE_CONTRACT_DELETE_ITEM_SUCCESS,
  SE_CONTRACT_DELETE_ITEM_ERROR,
  SE_CONTRACT_REPORT_GET_LIST,
  SE_CONTRACT_REPORT_GET_LIST_SUCCESS,
  SE_CONTRACT_REPORT_GET_LIST_ERROR,
} from '../actions';

const initialState = {
  seContracts: [],
  seContract: null,
  error: '',
  loading: false,
  addSuccess: false,
  editSuccess: false,
  deleteSuccess: false,
};

export default function reducerState(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case SE_CONTRACT_GET_BY_ID:
    case SE_CONTRACT_GET_LIST:
      return {
        ...state,
        loading: true,
        editSuccess: false,
      };

    case SE_CONTRACT_GET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        seContracts: payload,
      };

    case SE_CONTRACT_GET_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        seContract: payload,
      };

    case SE_CONTRACT_ADD_ITEM:
      return {
        ...state,
        loading: true,
        addSuccess: false,
      };

    case SE_CONTRACT_ADD_ITEM_SUCCESS:
      return {
        ...state,
        loading: false,
        seContracts: payload,
        addSuccess: true,
      };
    case SE_CONTRACT_EDIT_ITEM:
      return {
        ...state,
        loading: true,
        editSuccess: false,
      };

    case SE_CONTRACT_EDIT_ITEM_SUCCESS:
      return {
        ...state,
        loading: false,
        seContracts: payload,
        editSuccess: true,
      };

    case SE_CONTRACT_DELETE_ITEM:
      return {
        ...state,
        loading: true,
        deleteSuccess: false,
      };
    case SE_CONTRACT_DELETE_ITEM_SUCCESS:
      return {
        ...state,
        loading: false,
        seContracts: payload,
        deleteSuccess: true,
      };

    case SE_CONTRACT_REPORT_GET_LIST:
      return { ...state, loading: true };

    case SE_CONTRACT_REPORT_GET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        seContract: payload,
        error: null,
      };

    case SE_CONTRACT_REPORT_GET_LIST_ERROR:
    case SE_CONTRACT_GET_LIST_ERROR:
    case SE_CONTRACT_ADD_ITEM_ERROR:
    case SE_CONTRACT_EDIT_ITEM_ERROR:
    case SE_CONTRACT_DELETE_ITEM_ERROR:
    case SE_CONTRACT_GET_BY_ID_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return { ...state };
  }
}
